<template>
  <div class="paginated-html-email-template-component">

    <table v-if="hasTemplates" class="table">
      <thead>
      <tr>
        <th>Naam</th>
        <th>Pre-header</th>
        <th></th>
      </tr>
      </thead>
      <tbody :class="{ loading: loading }">
      <TemplateRowComponent
          v-for="template in currentRequestTemplates.data"
          :key="template.id"
          :template="template"
          @reload-templates="loadPaginatedTemplates(returnPage)"
          :can-edit="canEdit"
          :can-delete="canDelete"
      />
      </tbody>
    </table>

    <div v-else-if="loading && !hasTemplates" class="panel-body">
      <p>Laden...</p>
    </div>

    <div v-else class="panel-body">
      <p>Er zijn nog geen html-templates</p>
    </div>

    <div v-if="displayPagination" class="panel-body" style="padding-top: 0;">
      <laravel-pagination
          :data="currentRequestTemplates"
          @pagination-change-page="loadPaginatedTemplates"
          style="margin: 0;"
          size="small"
      ></laravel-pagination>
    </div>
  </div>
</template>

<script>
import htmlEmailTemplateApi from '~/api/html_email_template';
import TemplateRowComponent from "./RowComponent";

const moment = require('moment');

export default {
  name: 'HTMLEmailTemplateOverview',
  props: {
    canDelete: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TemplateRowComponent,
  },
  mounted() {
    this.loadPaginatedTemplates(1);
  },
  data() {
    return {
      currentRequestTemplates: {},
      loading: true,
    };
  },
  computed: {
    displayPagination() {
      return typeof this.currentRequestTemplates.meta !== "undefined";
    },
    returnPage() {
      let currentPage = this.currentRequestTemplates.meta.pagination.current_page || null;
      let dataLength = this.currentRequestTemplates.data.length;

      return dataLength < 1 ? currentPage - 1 : currentPage;
    },
    hasTemplates() {
      return this.currentRequestTemplates.data && this.currentRequestTemplates.data.length > 0;
    }
  },
  methods: {
    loadPaginatedTemplates(page = 1, perPage = 10) {
      this.loading = true;
      htmlEmailTemplateApi.paginate(page, perPage).then(
          (response) => {
            this.currentRequestTemplates = response;
            this.loading = false;
          },
      );
    },
  },
};
</script>

<style scoped>
.loading {
  opacity: .5;
}
</style>
